import React from 'react';
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {SearchProvider} from "v4/contexts/SearchContext/SearchContext";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ValidateImportFormTable
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTable/ValidateImportFormTable";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";
import {PolIcon} from "components/PolIcon/policon";
import PolButton from "v4/components/ui/PolButton/PolButton";

export default function ValidateImport({isProcessing}) {
    const {t} = usePolTranslation();
    const {prevStep, selectedEntityType} = useImportContext();

    return (
        <AdminCard title={`${selectedEntityType ? `${t(selectedEntityType)} -` : ''} ${t('validate_info')}`}
                   beforeTitleRender={() => (
                       <PolButton onClick={prevStep}
                                  className="mr-2 btn-primary">
                           <PolIcon icon="arrow-left"/>
                           {t('return')}
                       </PolButton>
                   )}>
            <SearchProvider>
                <ValidateImportFormTable isProcessing={isProcessing}/>
            </SearchProvider>
        </AdminCard>
    )
}
